<template>
  <div class="auth-wrapper auth-v2 container">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <!-- <h2 class="brand-text text-primary ml-1">
          Vuexy
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
          width="500px"
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <b-img
            width="170px"
              fluid
              :src="imgUrl1"
              alt="Login V2"
            />
          </div>
          <b-card-title
            class="mb-1 mt-4 font-weight-bold"
            title-tag="h2"
          >
            Welcome to My PODA 👋
          </b-card-title>
          <b-card-text class="mb-5">
            Sign in to manage ads, users, and platform activity.
          </b-card-text>
   <b-alert
   v-if="error"
        variant="danger"
        show
      >
        <h4 class="alert-heading">
          Error
        </h4>
        <div class="alert-body">
          <span>{{ error }}</span>
        </div>
      </b-alert>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="Enter Your Username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link style="color:black !important" :to="{name:'auth-forgot-password'}">
                    <small class="font-weight-bold">Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- :to="{name:dashboard-ecommerce}" -->
              <!-- submit buttons -->
              <b-button
                type="submit"
                style="background-color:black !important"
                block
                :disabled="invalid"
                >
                Log In
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">

            <span>New on our platform? </span>
            <b-link :to="{name:'auth-register'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { setupAdminWebPush } from '@/plugins/webPush'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import imgUrl from '../../../assets/images/svg/login-illustration.svg';
import imgUrl1 from '../../../../public/logo.png';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@/component/axios';;

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',imgUrl,imgUrl1,
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      error:'',
      // validation rules
      required,
      email,
    }
  },
  mounted() {
    clearInterval(this.$store.state.app.masterInterval)
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    // imgUrl() {
    //   if (store.state.appConfig.layout.skin === 'dark') {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
    //     return this.sideImg
    //   }
    //   return this.sideImg
    // },
  },
  methods: {
    login() {
      this.error=''
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          // let formdata = new FormData();
          // formdata.append('username',this.userEmail)
          // formdata.append('password', this.password)
          // let data={
          //   email: this.userEmail,
          //   password: this.password,
          // }
          // axios.post('http://rspt.local/api/v1/auth/admin/login', data).then(response => {
          //   if (response.data.error == false) {
              useJwt.login({
                email: this.userEmail,
                password: this.password,
              })
                .then(res => {
                  if(res.data.success){
                    const token = res.data.token || res.data.data?.token || res.data.access_token || ''
                    const userData = {...res.data.admin, token}
                  useJwt.setToken(token)
                  useJwt.setRefreshToken(token)
                  localStorage.setItem('userData', JSON.stringify(userData))
                  localStorage.setItem('accessToken', token)
                  this.$ability.update(
                  {
                    action: 'manage',
                    subject: 'all',
                  });
                  this.getAllStoreData()
                  setupAdminWebPush(this)
                  this.$router.push('/')
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Welcome ${userData.f_name}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully logged in as Admin. Now you can start to explore!`,
                        },
                      })
                    })
                  }
                  else{
                  this.error = res.data.errors[0].message
                  }
                })
                .catch((error) => {
                  const errors = error?.response?.data?.errors
                  this.error = (Array.isArray(errors) && errors[0]?.message)
                    || error?.response?.data?.message
                    || 'Invalid credentials.'
                })
            } else {
               this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Invalid Username and Password`,
                          icon: 'XIcon',
                          variant: 'danger',
                          text: `Enter Right Username & Password and Try Again `,
                        },
                      })
            }
                })
        // }
      // })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
